import { render } from "./AddFarmerModal1.vue?vue&type=template&id=6ce02db6&scoped=true"
import script from "./AddFarmerModal1.vue?vue&type=script&lang=js"
export * from "./AddFarmerModal1.vue?vue&type=script&lang=js"

import "./AddFarmerModal1.vue?vue&type=style&index=0&id=6ce02db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce02db6"]])

export default __exports__